<template><div><h1 id="artikelmerkmale" tabindex="-1"><a class="header-anchor" href="#artikelmerkmale"><span>Artikelmerkmale</span></a></h1>
<p>Artikelmerkmale — Kundenspezifische Markierung von Einzelartikeln</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Artikelmerkmale dienen der kundenspezifischen Markierung von Einzelartikeln. Dies kann für bestimmte Anforderungen notwendig oder zumindest hilfreich sein. Merkmale für Artikel können analog zu den Personenmerkmalen in einer Tabelle gepflegt und dann über das Programm Merkmale dem Einzelartikel zugewiesen werden. Im oberen Teilfenster werden Artikeldaten in Kurzform angezeigt, im unteren Teilfenster die eigentlichen Artikelmerkmale. Pro Artikel können beliebig viele Merkmale erfasst werden.</p>
<p>Pfad: <code v-pre>Logistik → Tabellen → Merkmale</code></p>
<h2 id="daten-artikel-kurzform" tabindex="-1"><a class="header-anchor" href="#daten-artikel-kurzform"><span>Daten Artikel (Kurzform)</span></a></h2>
<dl>
<dt>ArtNr.:</dt>
<dd>Artikelnummer</dd>
<dt>verfügbar:</dt>
<dd>Frei verfügbarer Bestand (Berechnet aus: [Verkaufbarer Bestand] - [Reservierter Bestand])</dd>
<dt>bestellt:</dt>
<dd>Bestellte Menge</dd>
<dt>VPreis:</dt>
<dd>Verkaufspreis</dd>
<dt>(Bez.):</dt>
<dd>Artikelbezeichnung in deutsch, französisch, italienisch auf unterster Zeile, ohne Beschriftung</dd>
</dl>
<h2 id="daten-artikelmerkmale" tabindex="-1"><a class="header-anchor" href="#daten-artikelmerkmale"><span>Daten Artikelmerkmale</span></a></h2>
<dl>
<dt>Merkmal:</dt>
<dd>Kürzel für Merkmal</dd>
<dt>Bedeutung:</dt>
<dd>Anzeige Merkmalsbedeutung</dd>
<dt>Typ:</dt>
<dd>Anzeige Merkmalstyp, Details siehe Tabellen</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/artikel_und_lagerverwaltung.html">Lagerverwaltung</RouteLink></p>
</div></template>


